export default __webpack_public_path__ + "static/ourlet.inspirations-d19d26a9bf36674bb8b07def79adf8e5.jpg";